'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiZoomInOutline = function TiZoomInOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.7 18.3h-3.4v-3.3c0-0.5-0.3-0.8-0.8-0.8s-0.8 0.3-0.8 0.8v3.3h-3.4c-0.4 0-0.8 0.4-0.8 0.9s0.4 0.8 0.8 0.8h3.4v3.3c0 0.5 0.3 0.9 0.8 0.9s0.8-0.4 0.8-0.9v-3.3h3.4c0.4 0 0.8-0.4 0.8-0.8s-0.4-0.9-0.8-0.9z m10.6 8.3l-3.7-3.8c0.3-1.2 0.6-2.4 0.6-3.6 0-6.5-5.3-11.7-11.7-11.7s-11.7 5.2-11.7 11.7 5.3 11.6 11.7 11.6c1.3 0 2.5-0.2 3.6-0.6l4 4c1 0.8 2.3 1.3 3.5 1.3 2.9 0 5.2-2.3 5.2-5.2 0-1.4-0.5-2.7-1.5-3.7z m-6.5-1.9l4.2 4.3c0.3 0.3 0.5 0.8 0.5 1.3 0 1-0.8 1.9-1.9 1.9-0.5 0-1-0.2-1.3-0.5l-4.2-4.2c1.1-0.8 2-1.7 2.7-2.8z m-16.6-5.5c0-4.6 3.7-8.4 8.3-8.4s8.3 3.8 8.3 8.4-3.7 8.3-8.3 8.3-8.3-3.7-8.3-8.3z' })
        )
    );
};

exports.default = TiZoomInOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/zoom-in-outline.js
// module id = 3843
// module chunks = 0